import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagBQ = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M7.322 7.322C1.964 12.68-.452 19.865.07 26.872L26.871.07C19.865-.452 12.68 1.964 7.322 7.322Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M8.927 44.147c9.822 8.264 24.506 7.775 33.751-1.47 9.245-9.245 9.734-23.928 1.47-33.75L8.927 44.146Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "m24.911 23.994 2.154-1.167-2.154-1.167a7.614 7.614 0 0 0-6.353-6.353l-1.167-2.154-1.167 2.154a7.614 7.614 0 0 0-6.352 6.353l-2.155 1.167 2.155 1.167a7.614 7.614 0 0 0 6.352 6.352l1.167 2.155 1.167-2.155a7.614 7.614 0 0 0 6.353-6.352Zm-7.52 3.18a4.348 4.348 0 1 1 0-8.695 4.348 4.348 0 0 1 0 8.695Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "m17.392 19.566.94 1.63h1.883l-.94 1.63.94 1.631h-1.882l-.941 1.63-.942-1.63h-1.882l.94-1.63-.94-1.63h1.882l.942-1.63Z"
}));
FlagBQ.displayName = 'FlagBQ';
export default withFlagWrapper(FlagBQ);
//# sourceMappingURL=index.js.map